import React from 'react';
import cn from 'classnames';

import { FixedOverlay } from 'components';
import { useIsMobile } from 'hooks';
import { AsyncQuickBetslip } from 'modules/betslip/async';
import SidebarTogglerDesk, { SidebarTogglerMob } from '../SidebarToggler';

import './footer.scss';

const Footer: React.FC = () => {
    const isMobile = useIsMobile();
    const SidebarToggler = isMobile ? SidebarTogglerMob : SidebarTogglerDesk;

    return (
        <FixedOverlay>
            <div
                styleName={cn('container', {
                    'is-mobile': isMobile,
                })}
            >
                <SidebarToggler />
                {isMobile && <AsyncQuickBetslip />}
            </div>
        </FixedOverlay>
    );
};

export default Footer;
